import { NavLink } from "react-router-dom";
import { BreadcrumbComponentProps } from "use-react-router-breadcrumbs";
import "./BreadcrumbItem.scss";

const BreadcrumbItem = (props: BreadcrumbComponentProps) => {
  const name = props.name as string;
  const pathname = props.match.pathname;
  return (
    <li key={name} className="breadcrumb-skat_item">
      <NavLink to={pathname}>{name}</NavLink>
    </li>
  );
};

export default BreadcrumbItem;
